import {
  Award,
  Factory,
  Laptop,
  Leaf,
  Package,
  Palette,
  Pill,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Sparkles,
  Truck,
  Utensils,
  Zap,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { TFunction } from "i18next";

// * ─── Types ──────────────────────────────────────────────────────────────────

export interface HomeServiceItem {
  icon: LucideIcon;
  titleKey: string;
  descriptionKey: string;
}

export interface HomeWhyChooseItem {
  icon: LucideIcon;
  titleKey: string;
  descriptionKey: string;
}

export interface HomeIndustryItem {
  icon: LucideIcon;
  nameKey: string;
}

export interface HomeTestimonial {
  name: string;
  company: string;
  role: string;
  text: string;
  rating: number;
}

// * ─── Data ───────────────────────────────────────────────────────────────────

export const HOME_SERVICE_ITEMS: HomeServiceItem[] = [
  {
    icon: Package,
    titleKey: "services.customBoxes.title",
    descriptionKey: "services.customBoxes.description",
  },
  {
    icon: Factory,
    titleKey: "services.corrugated.title",
    descriptionKey: "services.corrugated.description",
  },
  {
    icon: Sparkles,
    titleKey: "services.foodGrade.title",
    descriptionKey: "services.foodGrade.description",
  },
  {
    icon: Truck,
    titleKey: "services.retail.title",
    descriptionKey: "services.retail.description",
  },
];

export const HOME_WHY_CHOOSE_ITEMS: HomeWhyChooseItem[] = [
  {
    icon: Shield,
    titleKey: "whyChooseUs.quality.title",
    descriptionKey: "whyChooseUs.quality.description",
  },
  {
    icon: Leaf,
    titleKey: "whyChooseUs.sustainability.title",
    descriptionKey: "whyChooseUs.sustainability.description",
  },
  {
    icon: Zap,
    titleKey: "whyChooseUs.fastProduction.title",
    descriptionKey: "whyChooseUs.fastProduction.description",
  },
  {
    icon: Award,
    titleKey: "whyChooseUs.customDesign.title",
    descriptionKey: "whyChooseUs.customDesign.description",
  },
];

export const HOME_INDUSTRY_ITEMS: HomeIndustryItem[] = [
  { icon: ShoppingCart, nameKey: "industries.ecommerce" },
  { icon: Utensils, nameKey: "industries.foodBeverage" },
  { icon: Laptop, nameKey: "industries.electronics" },
  { icon: Palette, nameKey: "industries.cosmetics" },
  { icon: Pill, nameKey: "industries.pharma" },
  { icon: ShoppingBag, nameKey: "industries.retail" },
];

export const HOME_TESTIMONIALS: HomeTestimonial[] = [
  {
    name: "Sarah Johnson",
    company: "EcoBox Organics",
    role: "CEO",
    text: "Walnut Packaging transformed our brand with stunning eco-friendly boxes. Our customers love the premium feel!",
    rating: 5,
  },
  {
    name: "Michael Chen",
    company: "TechGear Pro",
    role: "Operations Manager",
    text: "Fast turnaround, excellent quality, and competitive pricing. They've been our packaging partner for 3 years.",
    rating: 5,
  },
  {
    name: "Emma Rodriguez",
    company: "Bella Cosmetics",
    role: "Brand Director",
    text: "The custom design team brought our vision to life. Our product packaging has never looked better!",
    rating: 5,
  },
];

const HOME_MARQUEE_KEYS = [
  "services.customBoxes.title",
  "whyChooseUs.sustainability.title",
  "whyChooseUs.fastProduction.title",
  "whyChooseUs.customDesign.title",
  "industries.ecommerce",
  "industries.foodBeverage",
  "industries.electronics",
  "industries.cosmetics",
  "industries.pharma",
  "industries.retail",
] as const;

export function getHomeMarqueeWords(t: TFunction): string[] {
  return HOME_MARQUEE_KEYS.map((key) => t(key));
}
